import { Divider } from "@material-ui/core"
import "./style.css"

const TypingProgress = ({ color = "#312E40" }) => <Divider className="typer" style={{ width: 18, height: 2, background: color }}/>

export default TypingProgress